import { render, staticRenderFns } from "./PageIndexElastic.vue?vue&type=template&id=5f50871f&"
import script from "./PageIndexElastic.vue?vue&type=script&lang=js&"
export * from "./PageIndexElastic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports